<div class="text-center mt-5" errorcode="404">
  <p>The page you requested could not be found. Please check your URL and try again.</p>
  <p><a [routerLink]="['']"> Return Home </a></p>
</div>
